const _CONFIG_ = {
  SITE_URL: "https://ori-hengongbet.com/",
  REGISER_URL: "https://hengongbet.com/en-my?regRef=Goodluck3324",
  GTM_ID: "G-Q25BW0B61S",
};
export default _CONFIG_;
